import { motion } from "framer-motion";
import { GALLERY } from "../../data";
import { fadeUp, viewportOnce } from "../../lib/motion";

export const Gallery = () => (
  <section id="galeria" data-testid="gallery" className="relative bg-ink py-24 sm:py-32 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="mb-14 sm:mb-20 max-w-2xl">
        <div className="overline mb-6">Galería</div>
        <h2 className="font-display font-light text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
          Lo que la cámara <em className="italic text-ember">apenas roza</em>
        </h2>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
        {GALLERY.map((img, i) => (
          <motion.figure
            key={i}
            data-testid={`gallery-item-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: [0.65, 0, 0.35, 1], delay: (i % 3) * 0.08 }}
            className="group relative overflow-hidden aspect-[4/5]"
          >
            <img
              src={img.src}
              alt={img.alt}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover transition-all duration-1000 ease-out group-hover:scale-110 grayscale-[0.3] group-hover:grayscale-0"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <figcaption className="absolute bottom-0 left-0 p-4 sm:p-5 opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
              <span className="font-body text-[0.7rem] sm:text-xs uppercase tracking-[0.2em] text-[var(--paper)]">{img.alt}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
